import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { PermissionsService } from '@core/services/permissions.service';
import { manageTraceabilityEnabledGuard } from '@features/configuration/guards/manage-traceability-enabled.guard';
import { of } from 'rxjs';

export const CompanyRoutes: Routes = [
  {
    path: 'company',
    title: 'Empresa',
    data: { icon: 'business', permission: 'company.view' },
    loadComponent: () => import('@features/company/company.component'),
    children: [
      // Registro
      {
        path: 'registry',
        title: 'Registro',
        data: { label: 'Registro', icon: 'content_paste', permission: 'company.registry.view' },
        loadComponent: () => import('@features/company/views/registry/registry.component'),
      },
      // Administradores
      {
        path: 'administrators',
        title: 'Gestionar administradores',
        data: {
          label: 'Administradores',
          icon: 'record_voice_over',
          permission: 'company.administrators.view',
        },
        children: [
          {
            path: '',
            title: 'Gestionar administradores',
            loadComponent: () =>
              import('@features/company/views/administrators/administrators.component'),
          },
          {
            path: 'fleet/:userId',
            title: 'Flotas asociadas',
            loadComponent: () =>
              import('@features/company/views/administrators/administrators-fleet/administrators-fleet.component'),
            data: {
              backFallback: '/company/administrators',
            },
          },
        ],
      },
      // Auditores
      {
        path: 'auditors',
        title: 'Gestionar auditores',
        data: { label: 'Auditores', icon: 'person_search', permission: 'company.auditors.view' },
        loadComponent: () => import('@features/company/views/auditors/auditors.component'),
      },
      // Flotas
      {
        path: 'fleets',
        title: 'Gestionar flotas',
        data: { label: 'Flotas', icon: 'local_shipping', permission: 'company.fleets.view' },
        children: [
          {
            path: '',
            title: 'Gestionar flotas',
            resolve: { createAction: () => of(true), exportAction: () => of(true) },
            loadComponent: () => import('@features/company/views/fleets/fleets.component'),
          },
          {
            path: ':fleetId/admins',
            title: 'Administradores de Flota',
            data: {
              backFallback: '/company/fleets',
            },
            loadComponent: () =>
              import('@features/company/views/fleets/views/fleet-admin/fleet-admin.component'),
          },
        ],
      },
      // Proveedores
      {
        path: 'suppliers',
        title: 'Gestionar proveedores',
        data: { label: 'Proveedores', icon: 'store', permission: 'company.suppliers.view' },
        // loadComponent: () =>
        //   import('@features/company/views/company-suppliers/company-suppliers.component'),
        children: [
          {
            path: '',
            title: 'Gestionar proveedores',
            loadComponent: () =>
              import('@features/company/views/company-suppliers/company-suppliers.component'),
          },
          {
            path: 'agreements/:supplierId',
            title: 'Acuerdos',
            loadComponent: () =>
              import('@features/company/views/company-suppliers/price-agreements/price-agreements.component'),
            data: {
              backFallback: '/company/suppliers',
            },
          },
          {
            path: 'attachments/:supplierId',
            title: 'Adjuntos',
            loadComponent: () =>
              import('@features/company/views/company-suppliers/supplier-attachments/supplier-attachments.component'),
            data: {
              backFallback: '/company/suppliers',
            },
          },
        ],
      },
      // Bandeja de vencimientos (visible solo si el flujo de aprobación está habilitado)
      {
        path: 'expirations',
        title: 'Gestionar vencimientos',
        canActivate: [manageTraceabilityEnabledGuard],
        resolve: { createAction: () => of(true), exportAction: () => of(true) },
        data: {
          label: 'Bandeja de entrada vencimientos',
          icon: 'mail_asterisk',
          hasCount: true,
          redirectWhenDisabled: '/company/registry',
          permission: 'company.expirations.view',
        },
        loadComponent: () => import('@features/company/views/expirations/expirations.component'),
      },
      {
        path: '',
        pathMatch: 'full',
        // El administrador no accede al registro de la empresa: entra por proveedores.
        redirectTo: () =>
          inject(PermissionsService).has('company.registry.view') ? 'registry' : 'suppliers',
      },
    ],
  },
];
